export interface CourseStoreStateType {
  chapters: { [key: string]: ChapterStateType };
  courses: NormalizedCourses;
  units: NormalizedUnits;
  videos: { [key: string]: VideoStateType };
  modules: NormalizedModules;
  resources: any;
  notes: any;
  result: any;
  enrolledList: any;
  message: string;
  totalPages: string;
  chaptersView: any;
  coursesView: any;
  unitsView: any;
  videosView: any;
  resultView: any;
  messageView: string;
  startProgress: boolean;
  totalCoursesNo: number;
  projectGrades: GradesType;
  assignmentGrades: GradesType;
  gradesLoading: boolean;
  coursesSearch: any;
  resultSearch: any;
  programs: {
    [id: string]: ProgramStateType
  };
  otherPrograms: {
    [id: string]: ProgramStateType
  },
  programList: ProgramListType[]
}

export interface ChapterStateType {
  id: string;
  title: string;
  description: string;
  videos: string[];
  quizDetails: QuizDetails;
  codeHubPlayGroundUrl: string;
  chapterResources: ChapterResource[];
  onsiteResources: OnsiteResource[];
  solutionVideoUrl?: string;
  type: string;
  assignmentUrl: string;
}

export interface OnsiteResource {
  title: string;
  originalFilename: string;
  size: number;
  fileUrl: string;
  htmlUrl: null | string;
  addedByUserId: string;
  addedByUserName: string;
  addedByUserEmail: string;
  addedOn: number;
}
export interface QuizDetails {
  id: string;
  title: string;
  questions: Question[];
  questionAnswerStates: QuestionAnswerState[];
}

export interface VideoStateType {
  id: string;
  title?: string;
  url: string;
  duration: number;
  imageUrl?: string;
}

export interface QuestionAnswerState {
  questionId: string;
  answers: string[];
  isCorrectAnswer: boolean;
  submittedDate: null;
}

export interface Question {
  title: string;
  id: string;
  type: QuestionType;
  options: Option[];
}

export interface Option {
  content: string;
  id: string;
}

export enum QuestionType {
  MultiChoice = "MULTI_CHOICE",
  SingleChoice = "SINGLE_CHOICE",
}

export interface NormalizedUnits {
  [id: string]: UnitsStateType;
}

export interface ChapterResource {
  id: string;
  content: string;
  type: ChapterResourceType;
  title?: string;
  url?: string;
  htmlContent?: string;
}

export enum ChapterResourceType {
  Blog = "Blog",
}
export interface UnitsStateType {
  id: string;
  title: string;
  description: string;
  moduleId: string;
  numberOfChapter: number;
  assignment: string[];
  chapter: string[];
  numberOfAssignment: number;
  codeHubModuleProjectUrl: string;
  deadLine: number;
  type: string;
}
export interface NormalizedModules {
  [id: string]: ModulesStateType
}
export interface ModulesStateType {
  id: string;
  title: string;
  totalUnits: number;
  totalAssignments: number;
  totalChapters: number;
  totalVideos: number;
  totalResources: number;
  totalQuizzes: number;
  totalVideoHours: number;
  moduleProjectId: string[];
  units: string[];
}
export interface ProgramListType {
  applicationApproval: boolean
  archived: boolean
  batchDtos: Array<{
    applicationClosingDate: number
    applicationEnable: string
    applicationOpeningDate: number
    batchId: string
    batchName: string
    batchStatus: string
    classroomOpeningDate: number
    createdOn: number
    examEnable: boolean
    noOfStudentsEnrolled: number
  }>
  organizationId: string,
  programDescription: string
  programId: string,
  programLocation: string
  programName: string
  schoolName: string,
  applyStatus: any,
  programApplicationStatus: string
}

export interface ProgramStateType {
  programName: string;
  code: string;
  courseList: string[];
  programDescription: string;
  programCoverImage: string;
  batchId: string;
  batchStatus: string;
  classroomOpeningDate: number;
  programBatchStatus: string;
  organizationName: string;
  schoolId: string;
  id: string;
}

export interface NormalizedCourses {
  [id: string]: CoursesStateType
}
export interface CoursesStateType {
  id: string;
  title: string;
  description: string;
  courseNumber: string;
  courseImageUrl: string | null;
  modules: string[];
  numberofModules: number;
}

export const CourseStoreState: CourseStoreStateType = {
  chapters: {},
  courses: {},
  units: {},
  videos: {},
  modules: {},
  resources: null,
  notes: null,
  result: [],
  enrolledList: null,
  message: '',
  totalPages: '0',
  chaptersView: null,
  coursesView: null,
  unitsView: null,
  videosView: null,
  resultView: null,
  messageView: '',
  startProgress: false,
  totalCoursesNo: 0,

  coursesSearch: null,
  resultSearch: [],
  projectGrades: {} as GradesType,
  assignmentGrades: {} as GradesType,
  gradesLoading: false,
  programs: {},
  otherPrograms: {},
  programList: []
};

export interface GradesType {
  id: string;
  noOfAttempts: number;
  taskId: string;
  totalScore: number;
  scoreReports: ScoreReport[];
  passingScore: number;
  resultStatus: string;
  type: string;
  highestScore: number;
  newHighScore: number;
  exercises: Exercise[];
}

export interface Exercise {
  name: string;
  score: number;
  totalScore: number;
  result: string;
  attempts: Attempt[];
}

export interface Attempt {
  submittedDate: number;
  score: number;
  totalScore: number;
  scoreStatus: string;
  status: string;
  output: null;
  exerciseName: string;
}

export interface ScoreReport {
  status: string;
  score: number;
  submittedDate: number;
}
